import React from "react";
import isoSitenso from "../../../assets/images/brand/iso-sitenso-negCyan.svg";
import { useNavigate } from "react-router-dom";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";

const NavUser = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    localStorage.removeItem("Usuario");
    navigate("/pgi/login");
  };

  const user = JSON.parse(localStorage.getItem('Usuario'))?.UserLogin?.name

  return (
    <>
      {/* Header */}
      <header id="headerPgi">
        <div className="d-flex">
        <h1 id="logoPgi">
          <a href="/pgi">
            <img src={isoSitenso} alt="" />
            PGI
          </a>
        </h1>
        <button className="button-nav-pgi">
          <a href="/" target="__blank" rel="noopener">
            Ver Sitio <ArrowForwardOutlinedIcon />
          </a>
        </button>
        </div>
        <div className="d-flex" id="navUserPgi">
          <div className="pgi_responsive">
          {user}
          </div>
          <button onClick={handleClick} type="button">
            log out
          </button>
        </div>
      </header>
    </>
  );
};

export default NavUser;
